export const numberToDecimalString = (number, precision = 2) => {
  const formatter = new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: precision,
  });

  return isNaN(number) ? '' : formatter.format(number);
};
